(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["la1970-branch-hub"] && !Shopify.designMode) return;
  try {
    function setupLaB2B() {
    const root = document.getElementById('la-branches');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const details = root.querySelector('#la-b2b-enquiry');
    const industry = root.querySelector('#LaB2BIndustry');
    root.querySelectorAll('[data-la-industry]').forEach(link => {
      link.addEventListener('click', () => {
        details.open = true;
        industry.value = link.dataset.laIndustry;
        requestAnimationFrame(() => industry.focus({preventScroll:true}));
      });
    });
    if (root.querySelector('.la-b2b__success, .la-b2b__errors') || location.hash === '#LaB2BContact') {
      details.open = true;
      details.scrollIntoView({block:'start'});
    }
  }
  setupLaB2B();
  document.addEventListener('shopify:section:load', setupLaB2B);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["la1970-chat-compact"] && !Shopify.designMode) return;
  try {
    const languageElement = document.getElementById('la-chat-language');
  if (languageElement) {
    const label = languageElement.dataset.label;
    const translateChat = () => {
      document.querySelectorAll('.chaty-app .on-hover-text, .chaty-app .chaty-app-sr-only').forEach(element => {
        if (element.textContent.trim() === 'Contact Us') element.textContent = label;
      });
      document.querySelectorAll('.chaty-app [aria-label], .chaty-app [data-hover], .chaty-app [data-text]').forEach(element => {
        ['aria-label', 'data-hover', 'data-text'].forEach(attribute => {
          if (element.getAttribute(attribute) === 'Contact Us') element.setAttribute(attribute, label);
        });
      });
    };
    const observer = new MutationObserver(translateChat);
    observer.observe(document.body, { childList: true, subtree: true });
    translateChat();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["la1970-offer-strip"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('la-offer-strip')) {
    customElements.define('la-offer-strip', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.la-offer-strip__slide')];
        this.index = 0;
        this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.pauseButton = this.querySelector('[data-pause]');
        this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => { this.show(this.index + Number(button.dataset.step)); this.restart(); }));
        this.pauseButton.addEventListener('click', () => { this.paused = !this.paused; this.updateButton(); this.restart(); });
        this.addEventListener('mouseenter', () => { this.hovered = true; });
        this.addEventListener('mouseleave', () => { this.hovered = false; });
        this.addEventListener('focusin', () => { this.focused = true; });
        this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) this.focused = false; });
        this.updateButton();
        this.restart();
      }
      disconnectedCallback() { clearInterval(this.timer); }
      show(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      }
      updateButton() {
        this.pauseButton.setAttribute('aria-pressed', String(this.paused));
        this.pauseButton.setAttribute('aria-label', this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel);
        this.pauseButton.textContent = this.paused ? '▶' : 'Ⅱ';
      }
      restart() {
        clearInterval(this.timer);
        if (!this.paused) this.timer = setInterval(() => { if (!this.hovered && !this.focused && !document.hidden) this.show(this.index + 1); }, 8000);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
